const top110 = [
  {
    id: 1,
    title: "Services Included in House Cleaning Services:",
    description: [
      {
        id: 1,
        name: "Includes of all Rooms Cleaning, Bathroom Cleaning, Kitchen Cleaning and Balcony Area Cleaning",
      },
      { id: 2, name: "Ceiling dusting" },
      { id: 3, name: "Fans/Ac dusting & Cleaning" },
      { id: 4, name: "Walls dusting" },
      { id: 5, name: "Window and channel cleaning" },
      {
        id: 6,
        name: "Curtain Cleaning, Sofa Cleaning, mattress & carpet vacuuming",
      },
      { id: 7, name: "Glass Cleaning" },
      {
        id: 8,
        name: "All Wooden Furniture, Doors, etc. cleaning and Polishing ",
      },
      { id: 9, name: "Floor Scrubbing" },
      {
        id: 10,
        name: "After removing the fridge, almirah, sofa, and cleaning the floor, the goods will be put back in place",
      },
      {
        id: 11,
        name: "Oil layer on the kitchen wall will be removed by the kitchen cleaner",
      },
      {
        id: 12,
        name: "Water stains, pan stains, or floor stains in the bathroom will be removed",
      },
    
    ]
  },
  {
    id: 2,
    title: "Materials & Equipment's Used In House Cleaning Services:",
    description: [
      { id: 1, name: " Professional cleaning chemicals" },
      { id: 2, name: "Single-disc floor scrubber/handheld scrubber" },
      { id: 3, name: "Vacuum Cleaner " },
      { id: 4, name: "Microfiber Cloths for dusting" },
      { id: 5, name: "Mops, Scotch Brite / foam or scrubbers. " },
      { id: 6, name: "Ladders, bucket, wiper and mugs etc." },
    ],
   
  },
  {
    id: 3,
    title: "Benefits Of Booking Us For Home Cleaning Services:",
    description: [
      {
        id: 1,
        name: "Best price guarantee: We offer you the best and lowest price offered in the market.",
      },
      { id: 2, name: "Five Star Rated Experts: Providing you with the top" },
      { id: 3, name: "certified and accomplished practitioners. " },
      {
        id: 4,
        name: "Timely Service: Our specialists are committed to delivering timely services.",
      },
      {
        id: 5,
        name: "100% safe chemicals usage: Our Experts use environmentally friendly chemicals.",
      },
    ],
  },
  {
    id: 4,
    title: "Safety Precautions Follows In House Cleaning Services:",
    description: [
      { id: 1, name: "Minimal touch contact & social distancing" },
      { id: 2, name: "Daily temperature monitoring." },
      { id: 3, name: "Wearing masks and gloves. " },
      { id: 4, name: "Regular sanitization of hands." },
      { id: 5, name: "Compliant of the Aarogaya Setu App." },
    ],
  },
];

export default top110;
